export default __webpack_public_path__ + "static/media/indicadorhum.27fd8809.png";